import { getRgObjectsOfType as n, RG_TYPE as d } from "@project-rouge/rg-core";
import { getLevelGlazedFacadeArea as s } from "../level-metrics/index21.js";
const f = (o) => {
  const a = n(o, d.Building);
  let t = 0;
  for (const l of a) {
    const r = new Set(l.data.levels.map((e) => e.levelIndex));
    for (const e of r)
      t += s(l, e);
  }
  return t;
};
export {
  f as getGlazedFacadeArea
};
//# sourceMappingURL=index27.js.map
